import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { PageTransition } from "@/components/PageTransition";

const Cookie = () => {
  const navigate = useNavigate();

  return (
    <PageTransition>
      <div className="min-h-screen bg-background">
        <header className="sticky top-0 z-40 bg-background/80 backdrop-blur-lg border-b border-border/50 px-4 py-3">
          <div className="flex items-center gap-3 max-w-3xl mx-auto">
            <button onClick={() => navigate(-1)} className="p-2 -ml-2 rounded-full hover:bg-muted transition-colors">
              <ArrowLeft className="w-5 h-5 text-foreground" />
            </button>
            <h1 className="text-lg font-bold text-foreground">Cookie Policy</h1>
          </div>
        </header>
        <main className="max-w-3xl mx-auto px-6 py-10 space-y-6">
          <h2 className="text-2xl font-bold text-foreground">Informativa sui Cookie</h2>
          <p className="text-sm text-muted-foreground">Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT")}</p>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold text-foreground">1. Cosa sono i cookie</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              I cookie sono piccoli file di testo che vengono memorizzati sul tuo dispositivo quando visiti un sito web. Vengono utilizzati per far funzionare il sito in modo più efficiente e per fornire informazioni ai proprietari del sito.
            </p>
          </section>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold text-foreground">2. Cookie tecnici</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Utilizziamo cookie tecnici necessari per il funzionamento del sito, come i cookie di sessione per l'autenticazione e le preferenze dell'utente (tema, lingua). Questi cookie non richiedono il consenso.
            </p>
          </section>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold text-foreground">3. Cookie analitici</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Potremmo utilizzare cookie analitici per comprendere come gli utenti interagiscono con il nostro sito, al fine di migliorare l'esperienza di navigazione. Questi dati sono raccolti in forma anonima e aggregata.
            </p>
          </section>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold text-foreground">4. Gestione dei cookie</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Puoi gestire le preferenze sui cookie attraverso le impostazioni del tuo browser. Tieni presente che la disabilitazione di alcuni cookie potrebbe influire sulla funzionalità del sito.
            </p>
          </section>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold text-foreground">5. Durata dei cookie</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              I cookie di sessione vengono eliminati alla chiusura del browser. I cookie persistenti rimangono sul dispositivo per un periodo di tempo definito o fino a quando non vengono eliminati manualmente.
            </p>
          </section>
        </main>
      </div>
    </PageTransition>
  );
};

export default Cookie;
